import type { MqttConnector } from '@/types/auth'

const DEFAULT_NAMESPACE = 'ofp'

/** 从 connector.userName（如 ofp_20000000_xxx）解析 namespace */
export function getMqttNamespace(connector: MqttConnector): string {
  const prefix = connector.userName.split('_')[0]
  return prefix || import.meta.env.VITE_MQTT_NAMESPACE || DEFAULT_NAMESPACE
}

/** 登录用户需订阅的 MQTT topic 列表 */
export function buildMqttSubscribeTopics(namespace: string, uid: number): string[] {
  return [
    `${namespace}/server/unicast/sys/${uid}/receive/0`,
    `${namespace}/server/unicast/mqtt/${uid}/receive/0`,
    `${namespace}/server/broadcast/sys/receive/0`
  ]
}
